/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'ordercustomer': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M96 128h832v96H96zm0 448h832v96H96zm0-224h832v96H96zm0 448h832v96H96z"/>'
  }
})
